import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroCarousel } from '../components/home/HeroCarousel';
import { ServicesGrid } from '../components/home/ServicesGrid';
import { StatsSection } from '../components/home/StatsSection';
import { CTASection } from '../components/home/CTASection';
import { GlobalNetwork } from '../components/home/GlobalNetwork';

export default function HomePage() {
  return (
    <div className="min-h-screen" data-testid="home-page">
      <Navbar />
      <main>
        <HeroCarousel />
        <StatsSection />
        <ServicesGrid />
        <GlobalNetwork />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
